<template>
    <div id="dashboard" class="column resumo-subsidio">
        <Filtro @atualizarDadosDoFiltro="atualizarDadosDoFiltro" :valorTotalDoProjeto="this.valorTotalDoProjeto"></Filtro>

        <DashboardParaMcmvCidades :dadosDoFiltro="this.dadosDoFiltro" @atualizarValorTotal="atualizarValorTotal">
        </DashboardParaMcmvCidades>

        <DashboardProjetos :dadosDoFiltro="this.dadosDoFiltro" @atualizarValorTotal="atualizarValorTotal">
        </DashboardProjetos>
    </div>
</template>

<script>
import DashboardParaMcmvCidades from "./DashboardParaMcmvCidades.vue";
import DashboardProjetos from "./DashboardProjetos.vue";
import Filtro from './Filtro.vue';

export default {
    components: { DashboardParaMcmvCidades, DashboardProjetos, Filtro },
    name: "dashboard",
    data() {
        return {
            dadosDoFiltro: {
                idCidade: null,
                idProjeto: null,
                projetoNome: '',
                projetoEhMcmvCidades: false
            },
            valorTotalDoProjeto: null,
        };
    },
    methods: {
        atualizarDadosDoFiltro(dadosDoFiltro) {
            this.dadosDoFiltro = dadosDoFiltro;
        },
        atualizarValorTotal(valorTotalDoProjeto) {
            this.valorTotalDoProjeto = valorTotalDoProjeto;
        }
    },
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?b395edd6